import { combineReducers } from 'redux'
import testReducer from './testReducer'
import darkModeReducer from "./interStatsMangement/darkModeReducer";
import pauseModalReducer from "./interStatsMangement/pauseModalReducer";
import examenReducer from "./ExamenReducer";
import generalHistoriquesReducer from "./generalHistoriquesReducer";
import revisionReducer from "./revisionReducer";
import multiSelectReducer from "./multiSelectReducer";
import userReducer from "./userReducer";
import reqErrorsReducer from "./interStatsMangement/reqErrorsReducer";
import commentsReducer from "./commentsReducer";


export default combineReducers({
    test: testReducer,
    darkMode: darkModeReducer,
    pauseModal : pauseModalReducer,
    examen : examenReducer,
    revision : revisionReducer,
    generalHistoriques : generalHistoriquesReducer,
    multiSelect : multiSelectReducer,
    user : userReducer,
    reqErrors : reqErrorsReducer,
    comments : commentsReducer
});

